import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';

export interface IFpCorrelationManagerState {
  popupId: string | null;
  selectedData: IFpCorrelationData | null;
  loading: boolean;
  initialized: boolean;
  activeTabConnectService: IFpCorrelationTabConnectService | null;
}

export const initialFpCorrelationManagerState: IFpCorrelationManagerState = {
  popupId: null,
  selectedData: null,
  loading: false,
  initialized: false,
  activeTabConnectService: null,
};
